"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cleanGeneratedHtmlCode = cleanGeneratedHtmlCode;
function cleanGeneratedHtmlCode(raw) {
    // Remove markdown code fences and explanations
    let code = raw
        .replace(/```html|```/gi, '') // Remove code fences
        .replace(/Here is the code for.*\n?/i, '') // Remove explanation line
        .trim();
    // Find the first <html> or <!DOCTYPE html> and slice from there
    const htmlStart = code.search(/<\s*!DOCTYPE\s+html.*>|<\s*html.*>/i);
    if (htmlStart !== -1) {
        code = code.slice(htmlStart);
    }
    return code;
}
